import script from "./AlertWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertWindow.vue?vue&type=script&setup=true&lang=js"

import "./AlertWindow.vue?vue&type=style&index=0&id=b6f4b08c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6f4b08c"]])

export default __exports__